import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';

const AUTH_IMAGES = [
  'images/DSC01640.jpg',
  'images/DSC01694.jpg',
  'images/DSC02654.jpg',
  'images/DSC02744.jpg',
  'images/DSC02932.jpg',
  'images/DSC02984.jpg',
  'images/DSC03174.jpg',
  'images/DSC04863.jpg',
  'images/DSC04915.jpg',
  'images/DSC05018.jpg',
  'images/DSC05022.jpg',
  'images/DSC05184.jpg',
  'images/DSC05731.jpg',
  'images/DSC06051-bewerkt.jpg',
  'images/DSC06170.jpg',
  'images/DSC06222.jpg',
  'images/DSC06646-bewerkt.jpg',
  'images/DSC09121.jpg',
  'images/DSC09177.jpg',
  'images/DSC09193.jpg',
  'images/DSC09230.jpg',
  'images/Lunet_Dennis_HR-3.jpg',
  'images/Lunet_Dennis_HR-12.jpg',
  'images/Lunet_Dennis_HR-25.jpg',
  'images/Lunet_Ralph_web-3.jpg',
  'images/Lunet_Ralph_web-5.jpg',
  'images/Lunet_Ralph_web-32.jpg',
  'images/Lunet_Ralph_web-38.jpg',
];

@Component({
  selector: 'app-auth-view',
  imports: [NgOptimizedImage],
  templateUrl: './auth-view.component.html',
  styleUrl: './auth-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthViewComponent {
  protected readonly randomImageSrc = signal(
    AUTH_IMAGES[Math.floor(Math.random() * AUTH_IMAGES.length)]
  );
  protected readonly imageLoaded = signal(false);
}
